<template>
  <div v-if="meta && meta.last_page > 1">
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item">
          <span class="page-link" aria-label="Previous" @click="changePage(1, day)">
            <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true" /></span>
            <span class="sr-only">Previous</span>
          </span>
        </li>
        <li class="page-item">
          <span class="page-link" aria-label="Previous" @click="prevPage">
            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true" /></span>
            <span class="sr-only">Previous</span>
          </span>
        </li>
        <li class="page-item" v-if="meta.current_page > 1">
          <span class="page-link" @click="changePage(meta.current_page - 1, day)">{{ meta.current_page - 1 }}</span>
        </li>
        <li class="page-item active">
          <span class="page-link" @click="changePage(meta.current_page, day)">{{ meta.current_page }}</span>
        </li>
        <li class="page-item" v-if="meta.current_page < meta.last_page">
          <span class="page-link" @click="changePage(meta.current_page + 1, day)">{{ meta.current_page + 1 }}</span>
        </li>
        <li class="page-item">
          <span class="page-link" aria-label="Next" @click="nextPage">
            <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true" /></span>
            <span class="sr-only">Next</span>
          </span>
        </li>
        <li class="page-item">
          <span class="page-link" aria-label="Next" @click="changePage(meta.last_page, day)">
            <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true" /></span>
            <span class="sr-only">Next</span>
          </span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    changePage: {
      type: Function,
      default: null,
    },
    meta: {
      type: [Object, String, Array],
      default: null,
    },
    day: {
      type: String,
      default: '',
    },
  },
  methods: {
    prevPage() {
      if (this.meta.current_page > 1) {
        this.changePage(this.meta.current_page - 1, this.day);
      }
    },
    nextPage() {
      if (this.meta.current_page < this.meta.last_page) {
        this.changePage(this.meta.current_page + 1, this.day);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue